import { getEnv } from '@luna/env';
import { getFeatureConfig } from '@luna/feature-config';

export function getCurrentFrontendEnvironment(): string | undefined {
    const { hostname } = window.location;

    const { availableEnvironments } = getFeatureConfig(({ devTools }) => devTools);

    return Object.entries(availableEnvironments).find(
        ([, environmentUrl]) => new URL(environmentUrl).hostname === hostname,
    )?.[0];
}

export function getCurrentApiTarget(): string | undefined {
    const { localApiBaseUrl, georgeApiUrl } = getEnv();

    const { availableApiTargets } = getFeatureConfig(({ devTools }) => devTools);

    const localApiTarget = Object.entries(availableApiTargets).find(([, apiTargetUrls]) =>
        localApiBaseUrl?.startsWith(apiTargetUrls[0]),
    )?.[0];

    if (localApiTarget) {
        return localApiTarget;
    }

    return Object.entries(availableApiTargets).find(([, apiTargetUrls]) =>
        georgeApiUrl?.startsWith(apiTargetUrls[0]),
    )?.[0];
}
